import { render, staticRenderFns } from "./DiagnosticSummary.vue?vue&type=template&id=1f3d74b0&"
import script from "./DiagnosticSummary.vue?vue&type=script&lang=js&"
export * from "./DiagnosticSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports